import type { ReactNode } from 'react';
import { color, radius } from './tokens';

export interface KpiTileProps {
  label: ReactNode;
  value: ReactNode;
  /** Colour of the value, e.g. a status foreground. */
  valueColor?: string;
}

/** One headline number with its label above it. */
export function KpiTile({ label, value, valueColor }: KpiTileProps) {
  return (
    <div
      style={{
        background: color.surface,
        border: `1px solid ${color.border}`,
        borderRadius: radius.card,
        padding: '16px 20px',
        display: 'flex',
        flexDirection: 'column',
        gap: 4,
      }}
    >
      <span style={{ fontSize: 13, color: color.textMuted }}>{label}</span>
      <b style={{ fontSize: 28, lineHeight: '36px', color: valueColor ?? color.text }}>{value}</b>
    </div>
  );
}
